import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
  
export const toastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export const notify = (message) => toast(message, toastOptions);
